<template>
  <div :class="backclass + ' dls'">
    <!-- <div class="fx_box"></div> -->
    <!-- 本页面完全遵照vw适配方案（非常离谱，建议使用计算器） -->
    <div class="read_center_box" id="read_center_box">
      <div class="read-topbar_c" v-show="ifShowMenu"></div>
      <div class="read-topbar" v-show="ifShowMenu">
        <i class="el-icon-arrow-left" @click="backnav"></i>
        <div class="topbar-opt">
          <!-- <div class="opt" @click="addsq">   有问题暂时注释
						<i class="el-icon-collection-tag"></i>
            <div class="opt-name">
              {{sqshow?'添加书签':'移除书签'}}
            </div>
          </div> -->
          <div class="opt" style="margin-left: 4vw" @click="changewenjian">
            <img src="@/assets/icon/read_change1.png" />
            <div class="opt-name">切换文件</div>
          </div>
        </div>
      </div>
      <div id="box">
        <div id="reader"></div>
      </div>
      <div
        :class="setshow ? 'read-bottom' : 'read-bottom shadow'"
        v-show="ifShowMenu"
      >
        <div class="menu" @click="showmulu">
          <img src="@/assets/icon/epubread_ico1.png" />
          <div class="menu-name">目录</div>
        </div>
        <div class="menu">
          <img src="@/assets/icon/epubread_ico2.png" />
          <div class="menu-name">亮度</div>
        </div>
        <div class="menu" @click="yejian">
          <img
            v-if="backclass !== 'zt_heise'"
            src="@/assets/icon/epubread_ico3.png"
          />
          <img
            v-if="backclass === 'zt_heise'"
            src="@/assets/icon/epubread_icoyejian.png"
          />
          <div class="menu-name">夜间</div>
        </div>
        <div class="menu" @click="showsetting">
          <img src="@/assets/icon/epubread_ico4.png" />
          <div class="menu-name">设置</div>
        </div>
      </div>
      <div class="setting_box" v-show="setshow">
        <div class="setting_li1">
          <span>字体</span>
          <div class="setting_li1c">
            <div class="left_button" @click="numreduce">A-</div>
            <div class="wenzi">{{ num }}</div>
            <div class="right_button" @click="numplus">A+</div>
          </div>
          <!-- <div class="setting_li1r">
            <span class="an">系统默认 ></span>
          </div> -->
        </div>
        <!-- <div class="setting_li1">
          <span>亮度</span>
          <div class="setting_li1c">
            <el-slider v-model="value1"></el-slider>
          </div>
        </div> -->
        <div class="setting_li3">
          <span>背景</span>
          <div class="setting_li1c">
            <span
              v-for="(item, index) in backgroundList"
              :key="index"
              :class="item.backclass === backclass ? 'active' : ''"
              :style="'background: ' + item.color"
              @click="changezt(item), result()"
            ></span>
          </div>
        </div>
      </div>
    </div>
    <el-drawer
      :visible.sync="drawer"
      size="82%"
      :show-close="false"
      direction="ltr"
      :before-close="handleClose"
    >
      <div style="padding-top: 36px">
        <div class="mul_title">{{ $route.query.fileName }}</div>
        <div id="certify">
          <div class="swiper-container">
            <div class="swiper-wrapper">
              <div style="cursor: pointer" class="swiper-slide">
                <div class="muli">
                  <div
                    :class="
                      item.href.indexOf(nowtitle) !== -1
                        ? 'muli_li cur'
                        : 'muli_li'
                    "
                    v-for="item in muluList"
                    @click="alig(item)"
                  >
                    {{ item.label }}
                  </div>
                </div>
              </div>
              <div style="cursor: pointer" class="swiper-slide">
                <div class="biji_box">
                  <div class="biji_box1">
                    笔记 ·<span>{{ highlights.length || 0 }}</span>
                  </div>
                  <div class="biji_box2">
                    <div
                      class="biji_box2_li"
                      v-for="item in highlights"
                      @click="highlightClick(item.textRange)"
                    >
                      <!-- <div class="biji_box2_lit">第一张</div> -->
                      <div class="biji_box2_lic">
                        <img src="@/assets/icon/epubread_icoshuqian.png" />
                        <span>{{ item.noteContent }}</span>
                      </div>
                      <div class="biji_box2_lib">{{ item.originalText }}</div>
                      <div class="biji_box2_libt">{{ item.createTime }}</div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- <div style="cursor: pointer" class="swiper-slide">
                <div class="biji_box">
                  <div class="biji_box1">书签 ·<span>{{BookMarkList.length||0}}</span></div>
                  <div class="biji_box2">
                    <div class="biji_box2_li" v-for="item in BookMarkList" @click="highlightClick(item.textRange)">
                      <div class="biji_box2_lic">
                        <img src="@/assets/icon/epubread_icoshuqian.png" />
                        <span>{{item.originalText}}</span>
                      </div>
                      <div class="biji_box2_libt">{{item.createTime}}</div>
                    </div>
                  </div>
                </div>
              </div> -->
            </div>
          </div>
        </div>
        <div class="tabs_box">
          <div
            @click="changecurrent(0)"
            :class="current === 0 ? 'tabs_li cur' : 'tabs_li'"
          >
            目录
          </div>
          <div
            @click="changecurrent(1)"
            :class="current === 1 ? 'tabs_li cur' : 'tabs_li'"
          >
            笔记
          </div>
          <!-- <div @click="changecurrent(2)" :class="current===2?'tabs_li cur':'tabs_li'">
            书签
          </div> -->
        </div>
      </div>
    </el-drawer>
    <div id="addnote" v-show="bjbtnshow" @click="addnote">
      <img src="@/assets/icon/epubread_icobj.png" />
      <span>添加笔记</span>
    </div>
    <mt-actionsheet
      :actions="bijiactions"
      v-model="bijiVisible"
      :closeOnClickModal="false"
    >
    </mt-actionsheet>
  </div>
</template>

<script>
import "swiper/css/swiper.css"; //引入swiper样式
import Swiper from "swiper"; //引入swiper
// import Epub from "../../../static/epub.js";
import Epub from "epubjs";
import { getToken, setToken, removeToken } from "@/utils/auth";
import {
  insertNote,
  update,
  removeNoteById,
  selectNoteListByFileId,
  selectFileLinkAndReadingLocation, //查看阅读文件地址和文件进度
  addBookMark,
  selectBookMarkList,
  selectTimeParameter, //获取调用阅读时长接口频率
  updateOcDownloadReading, //更新用户阅读时长
  updateOcReadSchedule, //更新阅读进度
} from "@/api/mobileterminalread/index.js";
import { MessageBox, Toast, Actionsheet } from "mint-ui";
export default {
  data() {
    return {
      tsonecontent: "该文件需要购买后才能阅读，是否确认购买", //提示框内容
      tsoneshow: false, //提示框开关
      tsonetitle: "购买", //提示框标题
      book: "",
      goodsFilePath: "", //阅读文件的地址
      isBookshelf: false,
      readdefault: 0,
      filesId: "",
      rendition: "",
      ifShowMenu: false, //工具栏
      current: 0,
      muluList: [], //目录list
      progress: 0, //进度条
      locations: {},
      drawer: false,
      mySwiper: undefined,
      nowmulu: "",
      setshow: false,
      value1: 0,
      backclass: "zt_moren", //主题的背景颜色class
      backgroundList: [
        {
          backclass: "zt_moren",
          color: "#f8f4e9",
        },
        {
          backclass: "zt_niupizhi",
          color: "#dbcfa5",
        },
        {
          backclass: "zt_danlvse",
          color: "#ebf1e5",
        },
        {
          backclass: "zt_danlanse",
          color: "#e9f5f5",
        },
        {
          backclass: "zt_danfense",
          color: "#f4e9e9",
        },
        {
          backclass: "zt_huise",
          color: "#e6e2e2",
        },
        // {
        // 	backclass: "zt_heise",
        // 	color: "#424242",
        // },
      ],
      num: 16,
      cfiRange: "", //当前选区的文字
      bjbtnshow: false,
      highlights: [],
      bijiVisible: false, //笔记操作按钮
      bijiactions: [
        {
          name: "修改",
          method: this.updateNote,
        },
        {
          name: "删除",
          method: this.notedelete,
        },
      ],
      bn: true, //无法处理的重复触发事件。用本字段来做延时
      notelsid: "", //临时存放笔记id
      notelsContent: "", //临时存放笔记内容
      nowtitle: "默认目录位置", //当前阅读位置的目录
      BookMarkList: [], //书签列表
      sqshow: true,
      TimeParameter: 10, //更新频次-单位分钟
      setInterval2: undefined,
      setInterval1: undefined,
      operationalState: 0,
    };
  },
  created() {
    // this.goodsFilePath='https://gateway.ysy.crtvup.com.cn/ouchn-source/goodsFile/downloadEncryptFile/1562771890513207298.epub?key=6bc5f671-164d-4ef0-8ec5-46bc2960045c'//this.$route.query.goodsFileUrl
    // setTimeout(() => {
    // 	this.showEpub();
    // }, 100)
    if (this.$route.query.goodsFileUrl) {
      this.goodsFilePath = this.$route.query.goodsFileUrl;
      setTimeout(() => {
        this.showEpub2();
      }, 100);
    } else if (this.$route.query.token) {
      setToken(this.$route.query.token);
      this.$store.state.user.token = this.$route.query.token;
      setTimeout(() => {
        this.tabbook();
      }, 100);
    }
  },
  components: {
    // Swiper
    MessageBox,
    Toast,
  },
  methods: {
    tabbook() {
      localStorage.setItem("token", this.$route.query.token);
      clearInterval(this.setInterval1);
      clearInterval(this.setInterval2);
      selectFileLinkAndReadingLocation({
        //判断是否有权限
        goodsFileId: this.$route.query.goodsFileId, //资源id
        goodsId: this.$route.query.goodsId,
        relevanceId: this.$route.query.relevanceId || undefined,
        resource: this.$route.query.resource,
        resourceType: this.$route.query.resourceType,
        token: this.$route.query.token,
      }).then((res) => {
        if (res.data.hasPermission) {
          //有权限
          this.goodsFilePath = res.data.filePath;
          this.initbook(res.data.readingLocation); //加载阅读方法并且跳转到阅读位置  readingLocation为阅读位置标记
          this.selectTimeParameter(); //获取更新进度和时长的频次   循环调用更新时长和更新进度方法
        } else {
          this.goodsFilePath = "";
          this.tsoneshow = true;
        }
      });
    },
    addsq() {
      var cfi = this.rendition.currentLocation().start.cfi;
      var originalText =
        this.rendition.getRange(cfi).startContainer.textContent === "\n"
          ? this.book.section(cfi).contents.innerText
          : this.rendition.getRange(cfi).startContainer.textContent;
      var sq = {
        fileId: this.$route.query.goodsFileId,
        originalText: originalText,
        textRange: this.book.section(cfi).href, //这个参数是错的   应该传当前页面的定位，现在传的是章节的定位
      };
      addBookMark(sq).then((response) => {
        Toast({
          message: "操作成功",
          iconClass: "el-icon-check",
        });
        this.selectBookMarkList();
      });
    },
    selectTimeParameter() {
      //获取更新 时长和进度 的频次
      selectTimeParameter().then((res) => {
        this.TimeParameter = res.data;
        this.setInterval2 = setInterval(() => {
          this.operationalState++;
          if (this.operationalState < 60) {
            this.updateOcDownloadReading(); //更新阅读时长
            this.updateOcReadSchedule(); //更新阅读进度
          }
        }, this.TimeParameter * 60000);
      });
    },
    updateOcDownloadReading() {
      //更新用户阅读时长接口
      updateOcDownloadReading({
        goodsFileId: this.$route.query.goodsFileId,
        goodsId: this.$route.query.goodsId,
        relevanceId: this.$route.query.relevanceId,
        resource: this.$route.query.resource,
        resourceType: this.$route.query.resourceType,
        teachInstId: this.$route.query.teachInstId,
      }).then((res) => {});
    },
    updateOcReadSchedule() {
      //更新阅读进度
      updateOcReadSchedule({
        fileId: this.$route.query.goodsFileId,
        readingLocation: this.rendition.currentLocation().start.href, //阅读进度
      }).then((res) => {});
    },
    updateNote() {
      this.$prompt("", "请输入笔记内容", {
        inputValue: this.notelsContent,
        inputType: "textarea",
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        showClose: false,
        closeOnClickModal: false,
        customClass: "yd_box",
        inputValidator: (value) => {
          // 点击按钮时，对文本框里面的值进行验证
          if (!value) {
            return "请输入笔记内容";
          }
          if (value.length > 1000) {
            return "不能超过1000字";
          }
        },
      })
        .then(({ value }) => {
          this.highlights.forEach((item, index) => {
            if (item.id === this.notelsid) {
              var note = item;
              note.noteContent = value.trim();
              //修改笔记内容
              update(note).then((response) => {
                Toast({
                  message: "操作成功",
                  iconClass: "el-icon-check",
                });
                this.getNoteList();
              });
            }
          });
        })
        .catch(() => {});

      // MessageBox.prompt('请输入笔记', {
      //   inputValidator: (val) => {
      //     if (val === null) {
      //       return true; //初始化的值为null，不做处理的话，刚打开MessageBox就会校验出错，影响用户体验
      //     }
      //     return !(val.length >= 1000)
      //   },
      //   inputErrorMessage: '不能超出1000字',
      //    inputValue:this.notelsContent
      // }).then((val) => {
      //   this.highlights.forEach((item,index)=>{
      //      if(item.id===this.notelsid){
      //        var note=item
      //        note.noteContent = val.value;
      //        //修改笔记内容
      //        update(note).then((response) => {
      //        	Toast({
      //        	  message: '操作成功',
      //        	  iconClass: 'el-icon-check'
      //        	});
      //        	this.getNoteList();
      //        });
      //      }
      //    })
      // }, () => {
      // })
    },
    notedelete() {
      MessageBox.confirm("确认删除吗?", "").then((action) => {
        removeNoteById(this.notelsid).then((response) => {
          for (let item of this.highlights) {
            //将查出来的每一条笔记高亮显示
            this.rendition.annotations.remove(item.textRange, "highlight");
          }
          this.getNoteList();
          Toast({
            message: "操作成功",
            iconClass: "el-icon-check",
          });
        });
      });
    },
    getNoteList() {
      //查询笔记
      selectNoteListByFileId(this.$route.query.goodsFileId).then((response) => {
        this.highlights = response.data;
        for (let item of response.data) {
          //将查出来的每一条笔记高亮显示
          this.rendition.annotations.remove(item.textRange, "highlight");
          this.rendition.annotations.highlight(
            item.textRange,
            {
              id: item.id,
              noteContent: item.noteContent,
            },
            (e) => {
              if (this.bn) {
                this.bn = false;
                this.bijiVisible = true;
                setTimeout(() => {
                  this.ifShowMenu = false;
                }, 50);
                this.notelsid = e.srcElement.dataset.id;
                this.notelsContent = e.srcElement.dataset.noteContent;
                setTimeout(() => {
                  this.bn = true;
                }, 500);
              }
            }
          );
        }
      });
    },
    addnote() {
      this.$prompt("", "请输入笔记内容", {
        inputType: "textarea",
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        showClose: false,
        closeOnClickModal: false,
        customClass: "yd_box",
        inputValidator: (value) => {
          // 点击按钮时，对文本框里面的值进行验证
          if (!value.trim()) {
            return "请输入笔记内容";
          }
          if (value.length > 1000) {
            return "不能超过1000字";
          }
        },
      })
        .then(({ value }) => {
          this.book.getRange(this.cfiRange).then((range) => {
            if (range) {
              this.note = {
                goodsId: this.$route.query.goodsId,
                goodsFileId: this.$route.query.goodsFileId,
                originalText: range.toString(),
                textRange: this.cfiRange,
                href: "#" + this.cfiRange,
                noteContent: value.trim(),
              };
              insertNote(this.note).then((res) => {
                Toast({
                  message: "操作成功",
                  iconClass: "el-icon-check",
                });
                this.getNoteList();
                this.cfiRange = "";
              });
            }
          });
        })
        .catch(() => {});
    },
    changezt(item) {
      //更换主题
      this.backclass = item.backclass;
    },
    IsBookshelfAdd() {
      //判断是否加入书架
      IsBookshelfAdd({
        goodsId: this.$route.query.goodsId,
        type: this.$route.query.resourceType,
      }).then((res) => {
        if (res.code == 200) {
          this.isBookshelf = res.data;
        }
      });
    },
    showsetting() {
      this.setshow = true;
    },
    clickmulu(item) {
      let _this = this;
      //点击目录获取进度，进度条滑动到指定位置
      this.rendition.display(item.href).then(() => {
        const currentLocation = _this.rendition.currentLocation();
        const progress =
          Math.floor(
            _this.locations
              .percentageFromCfi(currentLocation.start.cfi)
              .toFixed(5) * 10000
          ) / 100;
        _this.progress = progress;
        _this.mulushow = false;
        this.cfichange();
      });
    },
    initbook(readingLocation) {
      this.showEpub(readingLocation); //加载epub，传之前的阅读位置
      // this.initNoteList(); //获取笔记
      // this.selectReadInfo(); //获取阅读时长接口
    },
    // 电子书的解析和渲染
    showEpub(readingLocation) {
      this.book = new Epub(this.goodsFilePath);
      this.rendition = this.book.renderTo("reader", {
        width: window.innerWidth,
        height: window.innerHeight - 30,
      });
      this.rendition.display();
      var _this = this;
      this.book.loaded.navigation.then(function (toc) {
        /* _this.sliderMax = toc.length;*/
        _this.muluList = toc.toc;
        _this.nowtitle = toc.toc[0].href;
      });

      this.book.ready
        .then(() => {
          this.navigation = _this.book.navigation;
          //生成locations对象的定位符
          return _this.book.locations.generate();
        })
        .then(() => {
          //保存loactions对象
          this.locations = _this.book.locations;
        });

      this.rendition.on("touchstart", (e) => {
        this.touchStartX = e.changedTouches[0].clientX;
        this.touchStartTime = e.timeStamp;
      });
      this.rendition.on("touchend", (e) => {
        this.operationalState = 0;
        this.bjbtnshow = false;
        const offsetX = e.changedTouches[0].clientX - this.touchStartX;
        const time = e.timeStamp - this.touchStartTime;
        if (time < 500 && offsetX > 20) {
          this.prevPage();
          this.bijiVisible = false;
        } else if (time < 500 && offsetX < -20) {
          this.nextPage();
          this.bijiVisible = false;
        } else {
          this.setshow = false;
          this.showMenu();
        }
      });
      this.rendition.on("selected", (cfiRange, contents) => {
        this.cfiRange = cfiRange; //笔记选取
        // this.rendition.annotations.highlight(this.cfiRange, {}, (e) => {});
      });
      setTimeout(() => {
        this.rendition.hooks.content.register((contents, view) => {
          contents.document.addEventListener("contextmenu", (e) => {
            //删除默认事件
            document.getElementById("addnote").style.left = e.offsetX + "px";
            document.getElementById("addnote").style.top = e.pageY - 35 + "px";
            this.bjbtnshow = true;
            e.preventDefault();
            return false;
          });
        });
        this.getNoteList(); //获取所有笔记
        this.selectBookMarkList(); //获取书签
      }, 100);
      this.result();
      // setTimeout(()=>{
      //   document.addEventListener('touchstart', function(event) {
      //     alert(1)
      //       // 判断默认行为是否可以被禁用
      //       if (event.cancelable) {
      //           // 判断默认行为是否已经被禁用
      //           if (!event.defaultPrevented) {
      //               event.preventDefault();
      //           }
      //       }
      //   }, false);
      // },100)
    },
    // 电子书的解析和渲染
    showEpub2(readingLocation) {
      this.book = new Epub(this.goodsFilePath);
      this.rendition = this.book.renderTo("reader", {
        width: window.innerWidth,
        height: window.innerHeight - 30,
      });
      this.rendition.display();
      var _this = this;
      this.book.loaded.navigation.then(function (toc) {
        /* _this.sliderMax = toc.length;*/
        _this.muluList = toc.toc;
        _this.nowtitle = toc.toc[0].href;
      });

      this.book.ready
        .then(() => {
          this.navigation = _this.book.navigation;
          //生成locations对象的定位符
          return _this.book.locations.generate();
        })
        .then(() => {
          //保存loactions对象
          this.locations = _this.book.locations;
        });

      this.rendition.on("touchstart", (e) => {
        this.touchStartX = e.changedTouches[0].clientX;
        this.touchStartTime = e.timeStamp;
      });
      this.rendition.on("touchend", (e) => {
        this.bjbtnshow = false;
        const offsetX = e.changedTouches[0].clientX - this.touchStartX;
        const time = e.timeStamp - this.touchStartTime;
        if (time < 500 && offsetX > 20) {
          this.prevPage();
          this.bijiVisible = false;
        } else if (time < 500 && offsetX < -20) {
          this.nextPage();
          this.bijiVisible = false;
        } else {
          this.setshow = false;
          this.showMenu();
        }
      });
      this.rendition.on("selected", (cfiRange, contents) => {
        this.cfiRange = cfiRange; //笔记选取
        // this.rendition.annotations.highlight(this.cfiRange, {}, (e) => {});
      });
      setTimeout(() => {
        this.rendition.hooks.content.register((contents, view) => {
          contents.document.addEventListener("contextmenu", (e) => {
            //删除默认事件
            document.getElementById("addnote").style.left = e.offsetX + "px";
            document.getElementById("addnote").style.top = e.pageY - 35 + "px";
            this.bjbtnshow = true;
            e.preventDefault();
            return false;
          });
        });
      }, 100);
      this.result();
      // setTimeout(()=>{
      //   document.addEventListener('touchstart', function(event) {
      //     alert(1)
      //       // 判断默认行为是否可以被禁用
      //       if (event.cancelable) {
      //           // 判断默认行为是否已经被禁用
      //           if (!event.defaultPrevented) {
      //               event.preventDefault();
      //           }
      //       }
      //   }, false);
      // },100)
    },
    handleClose() {
      this.drawer = false;
    },
    selectBookMarkList() {
      selectBookMarkList({
        fileId: this.$route.query.goodsFileId,
      }).then((res) => {
        this.BookMarkList = res.data;
      });
    },
    showmulu() {
      this.drawer = true;
      this.current = 0;
      var that = this;
      setTimeout(() => {
        that.mySwiper = new Swiper("#certify .swiper-container", {
          autoplay: false,
          on: {
            slideChangeTransitionStart: function () {
              that.current = this.activeIndex;
            },
          },
        });
      }, 100);
    },
    changecurrent(e) {
      this.current = e;
      this.mySwiper.slideTo(this.current);
    },
    cfichange() {
      //书签按钮状态///
      var cfi = this.rendition.currentLocation().start.href;
      this.sqshow = true;

      this.BookMarkList.forEach((item, index) => {
        if (cfi === item.textRange) {
          //判断回显。
          this.sqshow = false;
        }
      });
    },
    nextPage() {
      if (this.rendition) {
        this.rendition.next().then(() => {
          this.nowtitle = this.rendition.currentLocation().start.href;
        });
        // this.rendition.next();
        this.ifShowMenu = false;
        this.setshow = false;
        this.cfichange();
      }
    },
    prevPage() {
      if (this.rendition) {
        this.rendition.prev().then(() => {
          this.nowtitle = this.rendition.currentLocation().start.href;
        });
        this.ifShowMenu = false;
        this.setshow = false;
        this.cfichange();
      }
    },
    showMenu() {
      this.ifShowMenu = !this.ifShowMenu;
    },
    alig(item) {
      let _this = this;
      //点击目录获取进度，进度条滑动到指定位置
      this.rendition.display(item.href).then(() => {
        this.nowtitle = this.rendition.currentLocation().start.href;
        const currentLocation = _this.rendition.currentLocation();
        const progress =
          Math.floor(
            _this.locations
              .percentageFromCfi(currentLocation.start.cfi)
              .toFixed(5) * 10000
          ) / 100;
        _this.progress = progress;
        this.cfichange();
      });
      this.ifShowMenu = false;
      this.drawer = false;
    },
    result() {
      this.setfont();
      this.changezt({
        backclass: this.backclass,
      });
      var hei = this.backclass === "zt_heise" ? "#ccc" : "#000";
      this.rendition.themes.default({
        "::selection": {
          background: "rgba(255,255,0, 0.3)",
        },
        ".epubjs-hl": {
          fill: "yellow",
          "fill-opacity": "0.3",
          "mix-blend-mode": "multiply",
        },
        body: {
          background: "rgba(255,255,255, 0)",
        },
        body: {
          color: hei,
        },
        ".tp-c": {
          "text-indent": "0",
        },
        p: {
          "text-indent": "0",
        },
        img: {
          "max-width": "100%!important",
        },
        pre: {
          "white-space": "pre-wrap",
          "word-wrap": "break-word",
        },
      });
    },
    highlightClick(epubcfi) {
      let _this = this;
      //点击目录获取进度，进度条滑动到指定位置
      this.rendition.display(epubcfi).then(() => {
        const currentLocation = _this.rendition.currentLocation();
        const progress =
          Math.floor(
            _this.locations
              .percentageFromCfi(currentLocation.start.cfi)
              .toFixed(5) * 10000
          ) / 100;
        _this.progress = progress;
        this.cfichange();
      });
      this.result();
      setTimeout(() => {
        this.result();
      }, 80);
      this.ifShowMenu = false;
      this.setshow = false;
      this.drawer = false;
    },
    backnav() {
      this.myUni.uni.postMessage({
        data: {
          name: "backnav",
          value: "1",
        },
      });
    },
    changewenjian() {
      this.myUni.uni.postMessage({
        data: {
          name: "changewenjian",
        },
      });
    },
    yejian() {
      if (this.backclass === "zt_heise") {
        this.backclass = "zt_moren";
      } else {
        this.backclass = "zt_heise";
      }
      this.result();
    },
    numplus() {
      if (this.num < 36) {
        this.num = this.num + 2;
      }
      this.setfont();
    },
    numreduce() {
      if (this.num > 12) {
        this.num = this.num - 2;
      }
      this.setfont();
    },
    setfont() {
      this.rendition.themes.fontSize(this.num + "px");
      for (let item of this.highlights) {
        //将查出来的每一条笔记高亮显示
        this.rendition.annotations.remove(item.textRange, "highlight");
        this.rendition.annotations.highlight(
          item.textRange,
          {
            id: item.id,
            noteContent: item.noteContent,
          },
          (e) => {
            if (this.bn) {
              this.bn = false;
              this.bijiVisible = true;
              setTimeout(() => {
                this.ifShowMenu = false;
              }, 50);
              this.notelsid = e.srcElement.dataset.id;
              this.notelsContent = e.srcElement.dataset.noteContent;
              setTimeout(() => {
                this.bn = true;
              }, 500);
            }
          }
        );
      }
    },
  },
};
</script>
<style scoped>
::v-deep ::-webkit-scrollbar {
  width: 0px;
}

#certify {
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

@import url("../../assets/styles/certify2.css");

.read_center_box {
  height: 92vh;
}

.read-topbar {
  position: absolute;
  top: 34px;
  z-index: 999;
  width: 100%;
  height: 11vw;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #ffffff;
  padding: 0 3.3vw;
  box-sizing: border-box;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}

.topbar-icon {
  font-size: 2.6vw;
  margin-left: 4.6vw;
}

.topbar-opt {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.topbar-opt .opt {
  height: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 2.9vw;
  line-height: 4.26vw;
  float: left;
}

.opt img {
  width: 3.46vw;
  float: left;
  margin-right: 1.33vw;
  margin-top: 0.4vw;
}

.opt .opt-name {
  font-size: 3.73vw;
  line-height: 4.26vw;
  color: #a0a0a0;
  float: right;
}

#reader {
  width: 100vw;
  height: calc(100vh - 34px);
}

.read-bottom {
  /* box-shadow: 0 0 2.66vw #ccc; */
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 100;
  width: 100vw;
  height: 14.5vw;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 4.66vw;
  background-color: #ffffff;
  text-align: center;
  box-sizing: border-box;
}

.menu {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.menu .menu-icon {
  font-size: 2.4vw;
}

.menu img {
  width: 5.8vw;
}

.menu .menu-name {
  font-size: 2.93vw;
  line-height: 4.26vw;
  color: #a0a0a0;
}

.muliclass {
  width: 83vw;
  height: 100vh;
  padding: 32rpx;
  box-sizing: border-box;
}

.box_topt {
  width: 100%;
  float: left;
  font-size: 4.26vw;
  line-height: 5.6vw;
  margin-bottom: 1.33vw;
  font-weight: bold;
}

::v-deep .el-drawer__header {
  padding: 0;
  margin-bottom: 0;
}

::v-deep .el-drawer__body {
  padding: 0 2.6vw;
  box-sizing: border-box;
}

.mul_title {
  width: 100%;
  margin-top: 7vw;
  margin-bottom: 3vw;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.tabs_box {
  width: 42.66vw;
  height: 8.53vw;
  background: #f2f2f2;
  border-radius: 4.28vw;
  margin: 4vw auto;
  display: flex;
  position: relative;
}

.tabs_li {
  flex: 1;
  width: 14.93vw;
  line-height: 8.53vw;
  text-align: center;
  font-size: 3.46vw;
  border-radius: 4.28vw;
}

.tabs_li.cur {
  background: #2e9adb;
  color: #fff;
}

.muli {
  width: 100%;
  overflow-y: auto;
  height: 80vh;
}

.muli_li {
  width: 100%;
  float: left;
  font-size: 4vw;
  line-height: 8vw;
  border-bottom: 1px solid #ddd;
  padding-top: 2vw;
  padding-bottom: 2vw;
}

.muli_li.cur {
  color: #2e9adb;
}

.biji_box {
  width: 100%;
  float: left;
  height: 80vh;
  overflow-x: hidden;
  overflow-y: auto;
}

.biji_box1 {
  width: 100%;
  float: left;
  font-size: 3.73vw;
  margin-top: 3.73vw;
  margin-bottom: 3vw;
}

.biji_box1 span {
  color: #2e9adb;
}

.biji_box2 {
  width: 100%;
  float: left;
}

.biji_box2t {
  width: 100%;
  float: left;
  font-size: 3.73vw;
  margin-bottom: 3.43vw;
}

.biji_box2_lic {
  width: 100%;
  float: left;
  margin-bottom: 2.66vw;
}

.biji_box2_lic img {
  width: 4.26vw;
  height: 4.26vw;
  display: inline-block;
  margin-bottom: -0.8vw;
  margin-right: 1.5vw;
}

.biji_box2_lic span {
  font-size: 3.73vw;
  line-height: 6vw;
}

.biji_box2_lit {
  width: 100%;
  float: left;
  font-size: 3.73vw;
  margin-bottom: 2.66vw;
}

.biji_box2_lib {
  width: 90%;
  margin-left: 7%;
  padding-left: 2%;
  box-sizing: border-box;
  border-left: 1.5px solid #ccc;
  float: left;
  word-break: break-all;
}

.biji_box2_libt {
  font-size: 2.66vw;
  color: #999999;
  text-align: right;
  width: 100%;
  float: left;
  margin-top: 2.76vw;
}

.biji_box2_li {
  width: 100%;
  float: left;
  border-bottom: 1px solid #f2f2f2;
  padding-bottom: 2.66vw;
  margin-bottom: 2.66vw;
}

/* 设置弹窗 */
.setting_box {
  width: 100%;
  position: fixed;
  bottom: 0;
  left: 0;
  height: 20vh;
  background: #fff;
  padding: 2.66vw;
  padding-top: 5vw;
  box-sizing: border-box;
  box-shadow: 0 0 8px #ccc;
}

.setting_li1 {
  width: 100%;
  float: left;
  margin-bottom: 6vw;
}

.setting_li1 .setting_li1c {
  width: 50%;
  float: left;
}

.setting_li1 span {
  float: left;
  width: 20%;
  font-size: 3.2vw;
  line-height: 6vw;
}

.setting_li1 .setting_li1r {
  width: 30%;
  float: left;
}

.setting_li1r .an {
  width: 25vw;
  height: 6vw;
  background: rgb(235, 235, 235);
  font-size: 3.4vw;
  border-radius: 3vw;
  line-height: 6vw;
  text-align: center;
  float: left;
}

.shadow {
  box-shadow: 0 0 8px #ccc;
}

.setting_li3 {
  width: 100%;
  float: left;
}

.setting_li3 span {
  float: left;
  width: 20%;
  font-size: 3.2vw;
  line-height: 6vw;
}

.setting_li1c span {
  width: 6.4vw;
  height: 6.4vw;
  float: left;
  border-radius: 50%;
  margin-right: 3vw;
}

.setting_li1c span.active {
  border: 1px solid #707070;
  text-align: center;
}

.setting_li1c .zt_heise.active {
  border: 1px solid #fff;
  text-align: center;
}

.setting_li1c .left_button {
  width: 12vw;
  height: 6vw;
  background: rgb(235, 235, 235);
  font-size: 3.4vw;
  border-radius: 3vw;
  line-height: 6vw;
  text-align: center;
  float: left;
}

.setting_li1c .wenzi {
  height: 6vw;
  font-size: 3.6vw;
  line-height: 6vw;
  text-align: center;
  width: 12vw;
  float: left;
}

.setting_li1c .right_button {
  width: 12vw;
  height: 6vw;
  background: rgb(235, 235, 235);
  font-size: 3.4vw;
  border-radius: 3vw;
  line-height: 6vw;
  text-align: center;
  float: left;
}

.zt_moren {
  background: #f8f4e9;
}

/* .zt_moren .read-topbar{ background-color:#f8f4e9;} */
/* .zt_moren .read-bottom{ background-color:#f8f4e9;} */
/* .zt_moren .setting_box{ background-color:#f8f4e9;} */
.zt_moren ::v-deep .el-drawer__body {
  background-color: #f8f4e9;
}

.zt_niupizhi {
  background: #dbcfa5;
}

/* .zt_niupizhi .read-topbar{ background-color:#dbcfa5;} */
/* .zt_niupizhi .read-bottom{ background-color:#dbcfa5;} */
/* .zt_niupizhi .setting_box{ background-color:#dbcfa5;} */
.zt_niupizhi ::v-deep .el-drawer__body {
  background-color: #dbcfa5;
}

.zt_danlvse {
  background: #ebf1e5;
}

/* .zt_danlvse .read-topbar{ background-color:#ebf1e5;} */
/* .zt_danlvse .read-bottom{ background-color:#ebf1e5;} */
/* .zt_danlvse .setting_box{ background-color:#ebf1e5;} */
.zt_danlvse ::v-deep .el-drawer__body {
  background-color: #ebf1e5;
}

.zt_danlanse {
  background: #e9f5f5;
}

/* .zt_danlanse .read-topbar{ background-color:#e9f5f5;} */
/* .zt_danlanse .read-bottom{ background-color:#e9f5f5;} */
/* .zt_danlanse .setting_box{ background-color:#e9f5f5;} */
.zt_danlanse ::v-deep .el-drawer__body {
  background-color: #e9f5f5;
}

.zt_danfense {
  background: #f4e9e9;
}

/* .zt_danfense .read-topbar{ background-color:#f4e9e9;} */
/* .zt_danfense .read-bottom{ background-color:#f4e9e9;} */
/* .zt_danfense .setting_box{ background-color:#f4e9e9;} */
.zt_danfense ::v-deep .el-drawer__body {
  background-color: #f4e9e9;
}

.zt_huise {
  background: #e6e2e2;
}

/* .zt_huise .read-topbar{ background-color:#e6e2e2;} */
/* .zt_huise .read-bottom{ background-color:#e6e2e2;} */
/* .zt_huise .setting_box{ background-color:#e6e2e2;} */
.zt_huise ::v-deep .el-drawer__body {
  background-color: #e6e2e2;
}

.zt_heise {
  background: #424242;
}

/* .zt_heise .read-topbar{ background-color:#5a5a5a; color:#f2f2f2;} */
/* .zt_heise .read-bottom{ background-color:#5a5a5a;} */
/* .zt_heise .setting_box{ background-color:#5a5a5a;} */
.zt_heise ::v-deep .el-drawer__body {
  background-color: #424242;
}

.zt_heise .menu .menu-name {
  color: #a0a0a0;
}

.zt_heise .mul_title {
  color: #f2f2f2;
}

.zt_heise .muli_li {
  color: #f2f2f2;
}

.zt_heise .biji_box1 {
  color: #f2f2f2;
}

.zt_heise .biji_box2_lit {
  color: #f2f2f2;
}

.zt_heise .biji_box2_lic span {
  color: #f2f2f2;
}

.zt_heise .biji_box2_lib {
  color: #f2f2f2;
}

.dls {
  padding-top: 34px;
  overflow: hidden;
  box-sizing: border-box;
  height: 100vh;
}

.top_s {
  height: 34px;
}

.read-topbar_c {
  height: 34px;
  background: #fff;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
}

#addnote {
  position: fixed;
  left: 0;
  top: 0;
  width: 16vw;
  height: 16vw;
  background: #fff;
  border-radius: 1.5vw;
  z-index: 1000;
  box-shadow: 0 0 2.66vw #ccc;
}

#addnote img {
  display: table;
  margin: 0 auto;
  margin-top: 3.5vw;
  width: 3.6vw;
}

#addnote span {
  width: 100%;
  font-size: 12px;
  float: left;
  line-height: 8vw;
  text-align: center;
  color: #999999;
}

.fx_box {
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  z-index: 1000;
  opacity: 0;
}
</style>
